module.exports = __webpack_public_path__ + "static/6-0a202102bf8ba8f6835aa1263ce85910.png";